import { Link } from "react-router-dom";

export default function CtaButton({
  to,
  children,
  className = "",
  testId,
  onClick,
}) {
  return (
    <Link
      to={to}
      data-testid={testId}
      onClick={onClick}
      className={`inline-flex min-h-12 items-center justify-center gap-2 rounded-lg bg-cta px-6 py-3 font-display text-base font-bold text-white shadow-sm transition-all duration-200 hover:bg-cta-hover hover:shadow-md ${className}`}
    >
      {children}
    </Link>
  );
}
